import { addAttachmentAtomType } from './addAttachmentAtomType';
/**
 * Adds an attachment for a certain atom type to a correlation.
 *
 * @param {Correlation} correlation
 * @param {string} atomType
 * @param {number} attachment
 */
export function addAttachment(correlation, atomType, attachment) {
    addAttachmentAtomType(correlation, atomType);
    if (!correlation.attachment[atomType].includes(attachment)) {
        correlation.attachment[atomType].push(attachment);
    }
    return correlation;
}
//# sourceMappingURL=addAttachment.js.map